import { FunctionComponent, useRef, useState, useCallback } from 'react';
import { Popper, ClickAwayListener } from '@mui/material';
import { Wrapper, PopperPaper, PopperOption } from './styled';

interface Props {
    onReviewRequest: () => void;
    onBeehiveReview: () => void;
    children: React.ReactNode;
    disabled?: boolean;
}

const ReviewSplitButton: FunctionComponent<Props> = ({
    onReviewRequest,
    onBeehiveReview,
    children,
    disabled = false
}) => {
    const anchorRef = useRef<HTMLDivElement>(null);
    const [open, setOpen] = useState(false);
    const closeTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);

    const clearPendingClose = () => {
        if (closeTimeout.current) {
            clearTimeout(closeTimeout.current);
            closeTimeout.current = null;
        }
    };

    const scheduleClose = useCallback(() => {
        closeTimeout.current = setTimeout(() => setOpen(false), 150);
    }, []);

    const handleMouseEnter = useCallback(() => {
        if (disabled) return;
        clearPendingClose();
        setOpen(true);
    }, [disabled]);

    const handleMouseLeave = useCallback(() => {
        scheduleClose();
    }, [scheduleClose]);

    const handleOptionClick = useCallback((action: () => void) => {
        setOpen(false);
        action();
    }, []);

    return (
        <ClickAwayListener onClickAway={() => setOpen(false)}>
            <Wrapper
                ref={anchorRef}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                {children}

                <Popper
                    open={open}
                    anchorEl={anchorRef.current}
                    placement="bottom-start"
                    style={{ zIndex: 1300 }}
                    onMouseEnter={clearPendingClose}
                    onMouseLeave={scheduleClose}
                >
                    <PopperPaper elevation={8}>
                        <PopperOption
                            onClick={() => handleOptionClick(onReviewRequest)}
                        >
                            Review by myself
                        </PopperOption>
                        <PopperOption
                            onClick={() => handleOptionClick(onBeehiveReview)}
                        >
                            Review by Beehive expert
                        </PopperOption>
                    </PopperPaper>
                </Popper>
            </Wrapper>
        </ClickAwayListener>
    );
};

export default ReviewSplitButton;
